<template>
  <div>
    <slot />
  </div>
</template>

<script>
import { useShortlists } from '@/states/shortlists/useShortlists'
import { provide } from '@vue/composition-api'

export const ShortistContextSymbol = Symbol('ShortlistContext id')

export default {
  setup() {
    const {
      shortlists,
      fetchShortlists,
      fetchShortlistsInProgress,
      createShortlist,
      setStartupShortlists,
      isSetStartupShortlistsInProgress,
      org,
      errors,
    } = useShortlists()
    fetchShortlists()

    const shortlistContext = {
      shortlists,
      fetchShortlists,
      fetchShortlistsInProgress,
      createShortlist,
      setStartupShortlists,
      isSetStartupShortlistsInProgress,
      org,
      errors,
    }
    provide(ShortistContextSymbol, shortlistContext)
  },
}
</script>
